import { ScheduleType } from '~/domain/PermanentJobs/enums/ScheduleType';
import { NumberUtils } from '~/utils/NumberUtils';

/**
 * Available benefits options for job postings
 */
export const benefitsOptions = [
  { code: 'Health Insurance', name: 'Health Insurance' },
  { code: 'Dental Insurance', name: 'Dental Insurance' },
  { code: '401(k)', name: '401(k)' },
  { code: 'Vision Insurance', name: 'Vision Insurance' },
  { code: 'Paid Time Off', name: 'Paid Time Off' },
  { code: 'Flexible Schedule', name: 'Flexible Schedule' },
  { code: 'Other', name: 'Other' },
];

/**
 * Schedule type options for job postings
 */
export const scheduleTypeOptions = [
  { code: ScheduleType.FULL_TIME, name: 'Full Time' },
  { code: ScheduleType.PART_TIME, name: 'Part Time' },
  { code: ScheduleType.FLEXIBLE, name: 'Flexible' },
];

/**
 * Expected days options for job postings
 * Code represents day of week (0 = Sunday, 1 = Monday, etc.)
 */
export const expectedDaysOptions = [
  { code: 0, name: 'Sunday' },
  { code: 1, name: 'Monday' },
  { code: 2, name: 'Tuesday' },
  { code: 3, name: 'Wednesday' },
  { code: 4, name: 'Thursday' },
  { code: 5, name: 'Friday' },
  { code: 6, name: 'Saturday' },
];

/**
 * Maximum length for job title
 */
export const jobTitleMaxLength = 50;

/**
 * Minimum length for job description
 */
export const jobDescriptionMinLength = 150;

/**
 * Maximum length for benefits other field
 */
export const benefitsOtherMaxLength = 100;

export function formatListingFee(price: number): string {
  return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
}

type TCountRule = { maxExclusive: number; divisor: number; unit: '' | 'k'; suffix: '' | '+' };

const PROFESSIONAL_COUNT_RULES: TCountRule[] = [
  { maxExclusive: 50, divisor: 1, unit: '', suffix: '' }, // 0-50: exact
  { maxExclusive: 500, divisor: 10, unit: '', suffix: '+' }, // 50-500: nearest 10+
  { maxExclusive: 1_000, divisor: 100, unit: '', suffix: '+' }, // 500-1k: nearest 100+
  { maxExclusive: 10_000, divisor: 1_000, unit: 'k', suffix: '+' }, // 1k-10k: nearest 1k+
  { maxExclusive: 100_000, divisor: 5_000, unit: 'k', suffix: '+' }, // 10k-100k: nearest 5k+
  { maxExclusive: Infinity, divisor: 10_000, unit: 'k', suffix: '+' }, // >100k: nearest 10k+
];

interface IFormatProfessionalCountOptions {
  thousandSeparator?: string;
}

/**
 * Formats a professional count into a human-readable string
 * e.g. 1000 -> "1k+", 45 -> "45", 750 -> "700+"
 */
export function formatProfessionalCount(
  count: number,
  options: IFormatProfessionalCountOptions = {},
): string {
  const { thousandSeparator = ',' } = options;
  const rule = PROFESSIONAL_COUNT_RULES.find((r) => count < r.maxExclusive)!;
  const rounded = Math.floor(count / rule.divisor) * rule.divisor;

  const display = rule.unit === 'k' ? rounded / 1_000 : rounded;
  const formatted = NumberUtils.applyThousandSeparator(display, thousandSeparator);
  return `${formatted}${rule.unit}${rule.suffix}`;
}
